<template>
	<div class="virtualCurrency">
		<div class="virtualCurrency-right" v-loading="loading">
			<div class="virtualCurrency-right__info">
				<div style="width:30%">
					<el-input placeholder="请输入内容，多个编号用英文(,)分隔" v-model="params.search" size="normal">
						<el-select v-model="params.select" slot="prepend" placeholder="请选择" size="normal">
							<el-option label="sn号" value="0"></el-option>
							<el-option label="IEMI号" value="1"></el-option>
							<el-option label="SimCard号" value="2"></el-option>
							<el-option label="ICCID" value="3"></el-option>
						</el-select>
					</el-input>
				</div>
				<el-button icon="el-icon-search" @click="handleCurrentChange(1)" size="small" type="primary">搜索</el-button>
				<!-- <el-button 
        type="primary" 
        size="small" 
        @click="addSnContacts"
        >新增SN号关联</el-button> -->
				<el-upload class="upload-demo" action="" multiple :http-request="({ file }) => {}" :show-file-list="false" :on-change="handleChange">
					<el-button class="update_btn" type="primary" size="small">上传文件</el-button>
				</el-upload>
				<el-button size="small" class="template_btn" @click="handleExport">模板下载</el-button>
				<el-button size="small" class="template_btn" @click="batchDel">批量删除</el-button>
				<el-button size="small" class="template_btn" @click="onExport">导出</el-button>
			</div>
			<el-table :data="tableData" stripe size="small" @selection-change="selectionChange" style="width: 100%;padding-bottom:20px;border-bottom:1px solid #eee;" height="calc(100% - 130px)" border>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column type="index" width="50" label="序号" />
				<el-table-column :prop="item.prop" align="center" :label="item.lable" :min-width="item.width || 110" v-for="(item, index) in tableHeader" :key="index"> </el-table-column>
				<el-table-column fixed="right" label="操作" width="140">
					<template slot-scope="scope">
						<span @click="onOpenForm(scope.row)" style="cursor: pointer;color: #4b88f6;margin-right:10px">修改 </span>
						<span @click="del(scope.row.sn)" style="cursor: pointer;color: #4b88f6;">删除 </span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				:current-page.sync="params.pageNumber"
				:page-sizes="[100, 200, 300, 400]"
				:page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="params.totalNum"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
			/>
		</div>
		<renewVue ref="renewVueRef" />
		<OverlayPackage ref="OverlayPackageRef" />

		<!-- SN号关联 -->
		<snContactDialog :addSnContactVisible="addSnContactVisible" @closeDialog="closeDialog" />
		<!-- 错误提示 -->
		<promtBox ref="promtBoxRefs" :list="errorList" />
		<!-- 修改SN号 -->
		<SnForm :visible.sync="snFormShow" :info="activeData" @onSuccess="search" />
	</div>
</template>
<script>
import myTree from '@/components/myTree/';
import { handleTree } from '@/util/handTree';
import renewVue from '@/components/renew/index.vue';
import OverlayPackage from '@/components/OverlayPackage/index.vue';
import snContactDialog from './snContactDialog.vue';
import promtBox from './promtBox.vue';
import SnForm from './snForm.vue';

export default {
	components: {
		myTree,
		renewVue,
		OverlayPackage,
		snContactDialog,
		promtBox,
    SnForm
	},
	data() {
		return {
      snFormShow:false,
      activeData:{},
			errorList: [],
			loading: false,
			params: {
				userId: this.$store.state.LOGINUSER.id,
				pageNumber: 1,
				pageSize: 100,
				totalNum: 0,
				select: '0',
				search: '',
			},
			// filterText:'',
			// defaultProps: {
			//   children: "children",
			//   label: "name",
			// },
			// treeData:[],
			tableData: [],
			tableHeader: [
				{
					lable: 'IMEI号',
					prop: 'imei',
				},
				{
					lable: 'SN号',
					prop: 'sn',
				},
				{
					lable: '卡号',
					prop: 'simCard',
				},
				{
					lable: '设备类型',
					prop: 'equipmentType',
				},
				{
					lable: 'ICCID',
					prop: 'iccid',
				},
			],
			// totalCorn:{},
			list: [],
			addSnContactVisible: false,
			sn: '',
		};
	},

	methods: {
    // 修改SN号
    onOpenForm(row){
      this.activeData = row;
      this.snFormShow = true;
    },
		//上传文件
		async handleChange(file) {
			let formData = new FormData();
			formData.append('file', file.raw);
			const { data } = await this.$API.uploadSN(formData);
			if (data.code == 0) {
				this.$message.success('上传成功');
				this.search();
			}
			if (data.data && data.code == -1) {
				this.errorList = data.data.split(';');
				this.$refs.promtBoxRefs.visible = true;
			}
			
		},
		//搜索
    async search () {
			if (this.params.search == '') return this.gerSnRelationAllInfo();
			const { data, total } = await this.$API.getSimBySpecifiedField({
				type: this.params.select,
				string: this.params.search.split(/[\n\s+,]/g).join(","),
        pageNumber:this.params.pageNumber,
        pageSize:this.params.pageSize,
			});
      this.tableData = data;
      this.params.totalNum = total;
			//console.log(this.tableData)
		},
		//新增SN号关联
		addSnContacts() {
			this.addSnContactVisible = true;
		},
		closeDialog() {
			this.addSnContactVisible = false;
			this.search();
		},
		//获取当前用户下所有sn关联信息
		async gerSnRelationAllInfo() {
			const { data, total } = await this.$API.gerSnRelationAllInfo({
				pageNumber: this.params.pageNumber,
				pageSize: this.params.pageSize,
			});
			this.params.totalNum = total;
			this.tableData = data;
			//console.log(this.tableData )
		},
		//下载模板
		handleExport() {
			window.open('/snRelation/downloadTemplate.json');
		},
		handleSizeChange(currentSize) {
			this.params.pageSize = currentSize;
			this.search();
		},
		handleCurrentChange(currentPage) {
			this.params.pageNumber = currentPage;
			this.search();
		},
		//根据sn号删除
		del(sn) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        const res = await this.$API.deleteSnInfo({ sn });
        if (res.code !== 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.search();
      }).catch(() => {});
		},
		// 批量选择
		selectionChange(rowList) {
			this.sn = rowList.map((row) => row.sn).toString();
		},
		//批量删除
		async batchDel() {
			const res = await this.$API.batchDeleteSnInfo({ data: this.sn });
			if (res.code !== 0) return this.$message.error(res.msg);
			this.$message.success(res.msg);
			this.search();
    },
    async onExport () {
      const res = await this.$API.exportSimBySpecifiedField({ 
        type: this.params.select,
				string: this.params.search.split(/[\n\s+,]/g).join(","),
      });
    }
	},
	created() {
		this.search();
	},
};
</script>
<style lang="scss" scoped>
.virtualCurrency {
	display: flex;
	overflow: hidden;
	position: absolute;
	left: 20px;
	right: 20px;
	top: 20px;
	bottom: 20px;
	.template_btn {
		float: right;
	}
	.update_btn {
		height: 34px;
		margin-left: 10px;
	}
	.virtualCurrency-left {
		width: 230px;
		padding: 20px;
		margin-right: 20px;
		background: #fff;
		display: flex;
		flex-direction: column;
	}
	.virtualCurrency-right {
		background: #fff;
		flex: 1;
		min-width: 900px;
		position: relative;
		padding: 10px;
		&__info {
			display: flex;
			justify-content: left;
			padding: 10px 0 20px 0;
			position: relative;
			> button {
				margin-left: 10px;
			}
			> .fr {
				position: absolute;
				right: 0;
				top: 2px;
				color: #333;
				font-size: 14px;
				> span {
					color: #f56c6c;
					display: inline-block;
					margin: 0 4px;
				}
				> button {
					margin-left: 10px;
				}
			}
			.el-input-group__prepend {
				padding: 0 5px;
			}
			.el-select {
				width: 115px;
				height: 32px;
			}
			/deep/ .el-input__inner {
				height: 34px;
			}
		}
	}
	.recharge_div {
		line-height: 34px;
		.el-col {
			margin-bottom: 10px;
			> span {
				color: #f56c6c;
				font-size: 16px;
			}
		}
	}
}
// .el-button{
//   height: 34px;
// }
</style>
